module.exports = __webpack_public_path__ + "static/media/login.81352e9f.png";